import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'TaxationSettings';
const ENDPOINT = `/taxation-settings/`;

@Injectable({
    providedIn: 'root'
})
export class TaxationSettingsService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
